module.exports = __webpack_public_path__ + "img/17.cc9bd47.webp";